// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_xrz","cls2":"TopBar-cls2_ig_ TopBar-cls1_xrz"};